import { render } from "./results-minimap.vue?vue&type=template&id=460668e6&scoped=true&ts=true"
import script from "./results-minimap.vue?vue&type=script&lang=ts"
export * from "./results-minimap.vue?vue&type=script&lang=ts"

import "./results-minimap.vue?vue&type=style&index=0&id=460668e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460668e6"]])

export default __exports__